'use strict';

angular.module('shiftTraderApp')
  .directive('workPeriodBar', function () {
    return {
      templateUrl: 'views/workPeriodBar/workPeriodBar.html',
      scope: {
        workPeriod: '=workPeriodBar',
        availableContext: '@context',
        hideClickthrough: '@'
      },
      bindToController: true,
      controllerAs: 'workPeriodBar',
      controller: ['$state', 'WorkPeriods', 'TimeService', function($state, WorkPeriods, TimeService) {
        var vm = this

        vm.viewShift = function () {
          $state.go('workPeriods', { userId: vm.workPeriod.user_id })
        }
      }]
    }
  })
